import { Input } from 'antd';
import PropTypes from 'prop-types';

const { TextArea } = Input;

// Just the textarea. The AND/OR/NOT/()/"" insert buttons that used to sit
// under it were dropped as visual clutter — the placeholder already spells the
// whole syntax out. insertTokenAtCursor (booleanQueryUtils) still ships as a
// library export for any project that wants to build its own toolbar.
//
// Client-side grammar errors/warnings are not validated in here — they're
// wired as antd Form.Item `rules` on the parent (one blocking, one
// `warningOnly`), so antd's own validateStatus/help rendering handles them
// consistently with every other field on the form. The only thing still shown
// locally is a server-rejected query, which is necessarily async and outside
// the rules lifecycle.
export default function BooleanQueryField({ field, value, onChange, disabled, serverError }) {
  return (
    <div className="sbv1-boolean-field">
      <TextArea
        rows={field.rows ?? 3}
        value={value ?? ''}
        disabled={disabled}
        status={serverError ? 'error' : undefined}
        placeholder={field.booleanPlaceholder ?? '(Java OR J2EE) AND "Spring Boot" NOT Hibernate'}
        onChange={(event) => onChange(event.target.value)}
      />
      {serverError && <div className="v1-input-validator-hint">{serverError}</div>}
    </div>
  );
}

BooleanQueryField.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  serverError: PropTypes.string,
};
